(ns manage.variants-preview-page.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["react-use/lib/useMedia$default" :as useMedia]
            [common.modal.view :refer [defmodal modal]]
            [common.widgets.input :refer [input]]
            [common.widgets.menu :refer [menu]]
            [common.widgets.overlay-page :as overlay-page]
            [manage.variants-preview-panel.view.core :refer [variants-preview-panel]]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui header-actions [{:keys [shared?]}]
  ($ Stack {:direction "row" :alignItems "center" :gap 1}
     (when-not shared?
       ($ Button
          {:start-icon ($ Icon "share")
           :variant "text"
           :onClick #(rf/dispatch [:modal/open {:id :preview-share-modal}])}
          "Share"))
     ($ menu
        {:icon "more_vert"
         :items [{:label "Add external template"
                  :on-click #(rf/dispatch [:ocp/open
                                           {:id :external-template/add}])}]})))

(defmodal id-warning :variants-preview-id-warning
  []
  [modal
   {:title "Variant not found"
    :footer [:> Button {:variant "contained"
                        :on-click #(rf/dispatch [:modal/close])} "OK"]}
   [:span "The variant for this preview URL does not exist anymore."]])

(defmodal draft-missing :missing-content-modal
  []
  [modal
   {:title "Preview is currently unavailable"}
   [:div {:style {:p "1rem"}}
    [:a "It's likely that this preview has expired or we are encountering a problem with our system."]
    [:br]
    [:a "Please contact the person who shared this preview with you."]]])

(defmodal share-link :preview-share-modal
  []
  (let [share-url @(rf/subscribe [:variants-preview.core/share-url])
        link-copied @(rf/subscribe [:variants-preview.core/value :link-copied])]
    [modal
     {:title "Share Preview"
      :footer ($ :<>
                 ($ Button {:variant "text"
                            :onClick #(rf/dispatch [:modal/close])}
                    "Cancel")
                 ($ Button {:variant "contained"
                            :onClick #(rf/dispatch-sync [:variants-preview.core/copy-share-link share-url])}
                    "Copy link")
                 (when link-copied
                   ($ Icon {:color "success"
                            :sx #js {:ml 1}}
                      "check")))}
     ($ Stack {:spacing 1}
        ($ :span "This is the link for sharing the preview page for 30 days with current settings:")
        ($ input
           {:readOnly true :value share-url}))]))

(defui variants-preview-content []
  (let [mobile? (useMedia "(max-width: 768px)")
        {url-variant-id :variant-id} (use-subscribe [:context/select-keys [:variant-id]])
        current-variant-id (use-subscribe [:variants-preview.variants/current-variant-id])]
    (uix/use-effect (fn []
                      (rf/dispatch [:variants-preview.core/init]))
                    [])

    (uix/use-effect (fn []
                      (rf/dispatch [:variants-preview.core/set-sidebar-visible (not mobile?)]))
                    [mobile?])

    ;; Warning modal to inform the user that the variant-id of the URL is not
    ;; the one being shown, probably because it no longer exists.
    (uix/use-effect (fn []
                      (when (and (some? url-variant-id)
                                 (some? current-variant-id)
                                 (not= url-variant-id (str current-variant-id)))
                        (rf/dispatch [:modal/open {:id :variants-preview-id-warning}]))
                      (rf/dispatch [:variants-preview.variants/get-content-feed]))
                    [url-variant-id current-variant-id])
    (r/as-element [:f> variants-preview-panel mobile?])))

(defui shared-variants-preview-page []
  (let [adset-name (use-subscribe [:resource.adset-preview/adset-name])
        display-mode (use-subscribe [:variants-preview.core/display-mode])]
    ($ overlay-page/overlay-page
       ($ overlay-page/header {:title "Preview" :entity-name adset-name}
          (when (#{:gallery :side-by-side} display-mode)
            ($ header-actions {:shared? true})))
       ($ variants-preview-content))))

(def variants-preview-page
  (uix/as-react
   (fn [{:keys [ref style onClose]}]
     (let [display-mode (use-subscribe [:variants-preview.core/display-mode])]
       ($ overlay-page/overlay-page {:ref ref :style style}
          ($ overlay-page/header {:title "Preview" :on-close onClose}
             (when (#{:gallery :side-by-side} display-mode)
               ($ header-actions)))
          ($ variants-preview-content))))))
